module.exports = __webpack_public_path__ + "img/材料力学5_7.0a4796dc.jpg";